import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { organisationTypeOptions } from 'src/api/types';
import { OrganisationType } from 'src/graphql/_generated';

interface OrganisationTypeSelectProps extends Omit<Props, 'value' | 'options'> {
  value: OrganisationType | undefined | null;
  onChange: (value: { label: string; value: OrganisationType }, meta: ActionMeta<any>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  restrictedTo?: OrganisationType[];
}

export const OrganisationTypeSelect: React.FC<OrganisationTypeSelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select organisation type',
  restrictedTo,
  ...rest
}) => {
  const options = restrictedTo
    ? organisationTypeOptions.filter((option) => restrictedTo.includes(option.value))
    : organisationTypeOptions;

  return (
    <>
      <CSelect
        isDisabled={disabled || !options.length}
        value={_.find(organisationTypeOptions, (o) => o.value === value)}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        onBlur={onBlur}
        inputId="organisation-type-select"
        name="organisationType"
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
